import * as types from './types';

const getPostingLeads = (postingId, days, startPeriod, endPeriod) => ({
  type: types.FETCH_POSTING_LEADS,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: `/panel/api/v1/statistic/posting/${postingId}`,
    method: 'GET',
    query: { days, startPeriod, endPeriod }
  }
});

const getPostingLeadsCharts = (postingId, days, startPeriod, endPeriod) => ({
  type: types.FETCH_POSTING_LEADS_CHARTS,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: `/panel/api/v1/statistic/posting/daily/${postingId}`,
    method: 'GET',
    query: { days, startPeriod, endPeriod }
  }
});

export { getPostingLeads, getPostingLeadsCharts };
